import React from 'react';
import * as Yup from 'yup';
import '../styles.scss';
import {connect} from 'react-redux';
import {Link, useHistory} from 'react-router-dom';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {compose} from 'redux';
import {
  AppForm,
  AppFormField,
  AppFormSubmitButton,
} from '../../../../components/forms';
import {Row} from '../../../../components/layout';
import {strings} from '../../../../util/strings';
import * as fonts from '../../../../util/fonts';
import colors from '../../../../util/colors';
import NewErrorMessage from '../../../../components/new-error-message';
import {Icons} from '../../../../util/icons';
import ModalTemplate from '../../../../components/modal';
import Icon from '../../../../components/icon';
import AppButton from '../../../../components/app-button';
import {setUser} from '../../../../store/actions';

export interface EnterCodeMobileProps extends RouteComponentProps {
  formik: any;
  setFormikContext(formik: any): void;
  setStepNumber(step: number): void;
  submitMobile(mobileNumber: any, isResend?: boolean): void;
  labels: typeof strings.pt.login;
  mobileNumber: number | string;
  globalStyles: any;
  disableResend: boolean;
  showResendConfirmation: boolean;
  showGeneralError: boolean;
  showForbiddenError: boolean;
  labelsMessages: typeof strings.pt.messages;
  showSubmitCodeError: boolean;
  submitCode(code: any): void;
  showWrongCodeError: boolean;
  showSuccessModal: boolean;
  setShowSuccessModal(value: boolean): void;
  route: any;
  user: any;
  setUser: Function;
  formKey: number;
}

const EnterCodeMobile = ({
  formik,
  setFormikContext,
  setStepNumber,
  submitMobile,
  labels,
  mobileNumber,
  globalStyles,
  disableResend,
  showResendConfirmation,
  showGeneralError,
  showForbiddenError,
  showSubmitCodeError,
  labelsMessages,
  showWrongCodeError,
  submitCode,
  showSuccessModal,
  setShowSuccessModal,
  route,
  user,
  setUser,
  formKey,
}: EnterCodeMobileProps) => {
  const validationSchema = Yup.object().shape({
    code: Yup.number()
      .typeError(labels?.login_confirmMobile_enterCode_wrongCode)
      .required(labelsMessages?.requiredField),
  });

  const history = useHistory();

  const renderSuccessModal = () => (
    <ModalTemplate
      className="code-success-container"
      contentClassName="code-success-content"
      show={showSuccessModal}
      onHide={() => {
        setShowSuccessModal(false);
        setUser({...user, mobile: mobileNumber});
        history.push({
          pathname: route,
        });
      }}
      cross={true}
      hideFooter={true}
      title={labels?.login_confirmMobile_headerTitle}
      titleStyle={{fontSize: 30, ...fonts.Bold, color: colors.black}}
      size="lg"
      lockClickOutside={true}>
      <div className="modal-body-container">
        <Row className="code-success-icon-row">
          <Icon
            name={Icons.SUCCESS}
            width={'40'}
            height={'40'}
            color={colors.black}
            className="icon-style"
            changeViewbox
            viewBox={'0 0 24 24'}
          />
        </Row>
        <Row className="code-success-title-row">
          <p
            style={{...fonts.MM, ...fonts.Bold, color: colors.black}}
            className="code-success-errorPopup">
            {labels?.login_confirmMobile_success_message}
          </p>
        </Row>
        <Row>
          <p style={fonts.M}>{labels?.login_confirmMobile_enterCode_success}</p>
        </Row>
        <Row className="code-success-submit-button-row">
          <AppButton
            title="Ok"
            variant="secondary"
            onClick={() => {
              setShowSuccessModal(false);
              setUser({...user, mobile: mobileNumber});
              history.push({
                pathname: route,
              });
            }}>
            Ok
          </AppButton>
        </Row>
      </div>
    </ModalTemplate>
  );

  return (
    <div>
      <AppForm
        className="communications-form-container"
        initialValues={{
          termsAccepted: false,
          privacyPolicyAccepted: false,
        }}
        validationSchema={validationSchema}
        key={formKey}
        onSubmit={async (values) => {
          submitCode(values.code);
        }}>
        <div className="confirm-mobile-content">
          <div>
            <Row
              style={{...fonts.M, ...fonts.Regular}}
              className="confirm-mobile-info">
              {labels?.login_confirmMobile_enterCode_subTitle}
            </Row>
            <Row
              style={{...fonts.M, ...fonts.Regular}}
              className="confirm-mobile-info-responsive">
              {labels?.login_confirmMobile_enterCode_subTitle}
            </Row>
            <Row
              style={{...fonts.M, ...fonts.Regular}}
              className="confirm-mobile-info">
              {`${labels?.login_confirmMobile_enterCode_formTopText} ${mobileNumber}`}
            </Row>
            <Row
              style={{...fonts.M, ...fonts.Regular}}
              className="confirm-mobile-info-responsive">
              {`${labels?.login_confirmMobile_enterCode_formTopText} ${mobileNumber}`}
            </Row>
            <div
              style={{
                textAlign: 'left',
                marginTop: 30,
                width: '60%',
                justifySelf: 'center',
              }}>
              <AppFormField
                showErrorMessage
                name="code"
                className="number-field"
                placeholder={
                  labels?.login_confirmMobile_enterCode_formPlaceholder
                }
                handleFormikContext={() => setFormikContext(formik)}
              />
            </div>
            {showForbiddenError && (
              <NewErrorMessage
                iconName={Icons.ALERT_PROBLEM}
                colorIcon={colors.alertRed}
                text={
                  labels?.login_confirmMobile_generalError
                }></NewErrorMessage>
            )}
            {showGeneralError && (
              <NewErrorMessage
                iconName={Icons.ALERT_PROBLEM}
                colorIcon={colors.alertRed}
                text={labelsMessages?.general_errorMessage}></NewErrorMessage>
            )}
            {showSubmitCodeError && (
              <NewErrorMessage
                iconName={Icons.ALERT_PROBLEM}
                colorIcon={colors.alertRed}
                text={labelsMessages?.general_errorMessage}></NewErrorMessage>
            )}
            {showWrongCodeError && (
              <NewErrorMessage
                iconName={Icons.ALERT_PROBLEM}
                colorIcon={colors.alertRed}
                text={
                  labels?.login_confirmMobile_enterCode_wrongCode
                }></NewErrorMessage>
            )}
            {showResendConfirmation && (
              <div className="app-center enter-code-resend-code-message">
                <span
                  style={{...fonts.M}}
                  className="enter-code-header">{`${labels?.login_confirmMobile_enterCode_codeSent}`}</span>
              </div>
            )}
            <Row className="app-center enter-code-resend-code">
              <span
                className={
                  disableResend
                    ? 'activate-registration-anchors-disable'
                    : 'activate-registration-anchors'
                }
                style={{
                  color: globalStyles?.primaryColor,
                  ...fonts.SemiBold,
                }}
                onClick={async () => {
                  if (!disableResend) submitMobile(mobileNumber, true);
                }}>
                {labels?.login_confirmMobile_enterCode_sendNewCode}
              </span>
            </Row>
          </div>
        </div>
        <Row className="continue-button-wrapper">
          <AppFormSubmitButton
            className="continue-button"
            variant="primary"
            title={labels?.login_confirmMobile_buttonText}
          />
        </Row>
        {showSuccessModal && renderSuccessModal()}
      </AppForm>
    </div>
  );
};

const mapStateToProps = ({strings, globalStyles, user}: any) => ({
  labels: strings.value.pt.login,
  globalStyles: globalStyles.value,
  labelsMessages: strings.value.pt.messages,
  user: user.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setUser: (value: any) => dispatch(setUser(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(EnterCodeMobile)),
);
